/*
 * @Author: bianbinbin
 * @Date: 2024-01-12 13:47:05
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-01-15 17:17:04
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/yearlyReport.js
 */

const yearlyReport = r => require.ensure([], () => r(require('@/views/yearlyReport/yearlyReport.vue'), 'yearlyReport'))

const router = [
  {
    path: '/yearlyReport',
    name: 'yearlyReport',
    meta: {
      title: '年度报告'
    },
    component: yearlyReport
  }
]

export default router
